
export const overlayStates = {
    none: 'NONE',
    resume: 'RESUME',
    form: 'FORM',
};

